// Company UI Config Service - Handles API interactions for company menu access and UI configurations

import { post, get, put } from "../utils/apiUtils";

const BASE_URL = `/api/v1/mms_persistence/company_ui_config`;

/**
 * Create company UI config (menu access levels)
 * @param {Object} payload - { companyId, menuAccessLevels }
 * @returns {Promise<Object>} Promise resolving to created config
 */
export const createCompanyUIConfig = async (payload) => {
  try {
    const response = await post(`${BASE_URL}`, payload);
    return response;
  } catch (error) {
    console.error('Error creating company UI config:', error);
    throw error;
  }
};

/**
 * Update company UI config (menu access levels)
 * @param {Object} payload - Full config object with id, companyId, menuAccessLevels, etc.
 * @returns {Promise<Object>} Promise resolving to updated config
 */
export const updateCompanyUIConfig = async (payload) => {
  try {
    const response = await put(`${BASE_URL}`, payload);
    return response;
  } catch (error) {
    console.error('Error updating company UI config:', error);
    throw error;
  }
};

/**
 * Fetch company UI config by company ID
 * @param {number} companyId - Company ID to fetch config for
 * @returns {Promise<Object>} Promise resolving to company config
 */
export const fetchCompanyUIConfig = async (companyId) => {
  try {
    const response = await post(`${BASE_URL}/fetch`, {
      filter: { companyId },
      sort: {}
    });
    return response;
  } catch (error) {
    console.error('Error fetching company UI config:', error);
    throw error;
  }
};

/**
 * Fetch all company UI configs with pagination
 * @param {number} skip - Number of records to skip
 * @param {number} limit - Number of records to fetch
 * @param {Object} filter - Filter criteria
 * @returns {Promise<Object>} Promise resolving to list of configs
 */
export const fetchAllCompanyUIConfigs = async (skip = 0, limit = 10, filter = {}) => {
  try {
    const response = await post(`${BASE_URL}/fetch?skip=${skip}&limit=${limit}`, {
      filter,
      sort: {}
    });
    return response;
  } catch (error) {
    console.error('Error fetching all company UI configs:', error);
    throw error;
  }
};

export default {
  createCompanyUIConfig,
  updateCompanyUIConfig,
  fetchCompanyUIConfig,
  fetchAllCompanyUIConfigs
};
